// Title case: first letter of each word capitalized
export const toTitleCase = (str) => {
  if (!str) return str;
  return str.replace(/\b\w/g, (c) => c.toUpperCase());
};

// Handle title case input change
export const titleCaseChange = (e, setForm) => {
  const { name, value } = e.target;
  setForm(prev => ({ ...prev, [name]: toTitleCase(value) }));
};

// Phone: only digits, max 10, first digit must be 5-9
export const phoneChange = (e, setForm) => {
  const { name, value } = e.target;
  let digits = value.replace(/\D/g, '');
  if (digits.length > 0 && !/^[5-9]/.test(digits)) digits = digits.slice(1);
  if (digits.length > 10) digits = digits.slice(0, 10);
  setForm(prev => ({ ...prev, [name]: digits }));
};

// Validate phone: exactly 10 digits, starts with 5-9
export const isValidPhone = (phone) => /^[5-9]\d{9}$/.test(phone);

// Indian states list
export const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
  'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
  'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry',
];
